import { graphql } from "gatsby";
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, {useEffect, useContext} from 'react';
import {Header} from '../components/header/header';
// import Layout from '../components/layout';
import Looks from '../components/looks/looks';
import {Footer} from '../components/footer/footer';
import { GlobalContext } from "../layouts/globalContext.js";

const CollectionPage = () => {
 const { t } = useTranslation();
  let products = t('productList', { returnObjects: true });
  const { enter, setEnter } = useContext(GlobalContext);
  

  
  useEffect(()=>{
    if(!document.body.classList.contains('entry-anim')){      
      document.body.classList.add('entry-anim');
    }
    if(document.body.classList.contains('glitch-anim')){      
      document.body.classList.remove('glitch-anim');
    }
    setEnter(true);
  }, [])
  return (
      <>
        <Header></Header>
        <Looks products={products}></Looks>      
        <Footer></Footer>
      </>
      // <CollectionProducts></CollectionProducts>
  );
};

export default CollectionPage;


export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
